/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AppService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from './project.service';
import { LocalStorageService } from './localstorage.service';
import { AbInfoPopupService } from './ab-info-popup.service';
import { QuickViewPopupService } from './quick-view-popup.service';
import { SearchLogService } from './search-log.service';

@Injectable({
  providedIn: 'root'
})
export class SaveIdeaService {
  isLoadSpace!:boolean;
  product_add_action="";
  main_space_select_all_flag!: boolean;
  user_product_data: any;
  is_next_option!: boolean;
  slug_name:any;
  project_id:any;
  isSelectProduct!: boolean;
  isBtnShow!: boolean;
  selected_space_list: any[]=[];
  tagged_product: any;
  activeSCId: any;
  isShowSummryBtn!: boolean;
  tagged_in_spaces_count!: number;
  temp_product_id: any;
  activeProd:any;
  activePos:any;
  activerSpaceID: any;
  currentSubCategoryName:any;
  isCloseAddSpace!: boolean;
  isSimilarProduct: any;
  similarProductDetail: any;
  similar_product_loading!: boolean;
  total_products: any;
  total_pages: any;
  similar_product_list: any[]=[];
  displaySimilarProducts!: boolean;
  sub_slug_name!: string;
  spPage!: string;
  productSelectAllMap: Map<number, boolean> = new Map();
  isPopups!: boolean;
  diplayAddSpace!: boolean;
  addSpacerrorMsg: undefined;
  isrequresSpaces!: boolean;
  isaddProductSlider!: boolean;
  tagged_productlength: any;
  space_id: any;
  required_space_list: any;
  sysMainSpace: any;
  sysAttachedSpace: any;
  global_loader!: boolean;
  mobAddSpacedisplay!: boolean;
  addSpacedisplay!: boolean;
  sub_category_index!: number;
  temp_product_pos: any;
  productList: any;
  activekey: any;
  shareLink!: string;
  shareDiscription!: string;
  labelText!: string;
  constructor(private _as:AppService,private _router:Router,private _actRouter:ActivatedRoute,private _project:ProjectsService,private _sl:SearchLogService,
    private localStorageService: LocalStorageService,private _abpopupinfo:AbInfoPopupService,private _qvs:QuickViewPopupService) { 
    
  }

  addProductSpace(prod: any, pos?: number, flag?: any) {
    
    // this.prods = prod;
    this.tagged_product = prod;
    this.activePos = pos;
    this.activeProd = prod;
    this.product_add_action = flag
    this._qvs.displayQuickview = false;
    this._router.navigate([], {
      relativeTo: this._actRouter, queryParams: { subCat:this.tagged_product.sub_category_id},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    if (!this.localStorageService.getItem('isinfopopupSaveIdea') && !this._as.isUserLoggedIn) {
      this._abpopupinfo.displaySaveIdeaInfoPopup();
      return
    }
    if (!this._as.isUserLoggedIn) {
      setTimeout(() => {
        this._as.isDisplayLogin = true;
      }, 200);
      return
    }
    this.diplayAddSpace = true;
    this.isLoadSpace = true;
    if (this._project.main_space_list.length) {
      this.onSeletedProduct(prod, pos, true);
      if (this.temp_product_id in this.productSelectAllMap) {
        this.main_space_select_all_flag = true;
      } else {
        this.main_space_select_all_flag = false;
      }
      this.isPopups = true;
      this.checkMainSpaceStatus();
      this._project.isdisplayTagSpaces = true;
    } 
    else {
      this.addToSpace(prod, pos);
    }


    this.localStorageService.setItem('Doneredirectononsame', JSON.stringify(false));
  }

  addToSpace(prod?: any, pos?: any) {
    this.addSpacerrorMsg = undefined;
    if (!this._project.selectedProject.id) {
      console.log("Project not fond")
      try {
        if (!this._project.selectedProject) {
          console.log("project not selected")
          this._project.onDisplayProjects(false);
          return
        } else {
          this.project_id = this._project.selectedProject.id;

        }
      } catch {
        
        this.project_id = undefined;
        let user_selected_space_list = []
        try {
          user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '') ;
        }catch{
          user_selected_space_list = [];
        }
        if (user_selected_space_list.length) {
          this.createUserSapce(prod, pos, user_selected_space_list)
        } else {

          this.activePos = pos;
          this.activeProd = prod;
          this.isrequresSpaces = true;
        }
        return
      }
    }else{
      this.project_id = this._project.selectedProject.id
    }
    const url = this._as.api_base_url + 'search/selectspacelist/?project=' + this.project_id + '&sub_category=' + this._qvs.productDetail.sub_category_id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this._project.main_space_list = res.data;
        if (!this._project.main_space_list.length) {
          // when user not selcted spaces then redirect to select space spage
          let user_selected_space_list = []
          try {
             user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '') ;
          }catch{
            user_selected_space_list = []
          }
          
          if (user_selected_space_list.length) {
            this.createUserSapce(prod, pos, user_selected_space_list)
          } else {
            this.isrequresSpaces = true;
            if (prod) {
              this.activeProd = prod;
              this.activePos = pos;
              this.isaddProductSlider = true;
            } else {
              this.activeProd = undefined;
              this.activePos = undefined;
              this.isaddProductSlider = false;
            }
          }
        } else {
          this.localStorageService.removeItem('user_selected_space_list')
          if (prod) {
            this.addProductSpace(prod, pos)
          } else {
            this.onSeletedProduct(prod, pos, false);
          }
        }
        for (const sb of this._project.main_space_list) {
          for (const subspace of sb.sub_space_list) {
            this.tagged_productlength = subspace.tagged_products;
            if (this.tagged_productlength.length) {
              return;
            }
          }
        }
   
      },
        (err: any) => {
          this._project.main_space_list = [];
          let redirectTo = [];
          try {
            redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '');
          }catch{
            redirectTo = []
          }
          if (redirectTo) {
            let user_selected_space_list = []
            try{
              user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '') ;
            }catch{
              user_selected_space_list =[]
            }
            if (user_selected_space_list.length && !err.error.required_space_list) {
              this.createUserSapce(prod, pos, user_selected_space_list)
            } else {
              this.space_id = err.error?.required_space_list[err.error?.required_space_list?.length - 1]
              this.isrequresSpaces = true;
              this.required_space_list = err.error.required_space_list;
            }
            this.required_space_list = err.error.required_space_list;
          } else {
            let user_selected_space_list = []
            try{
              user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '') ;
            }catch{
              user_selected_space_list =[]
            }
            if (user_selected_space_list.length && !err.error.required_space_list) {
              this.createUserSapce(prod, pos, user_selected_space_list)
            } else {
              if (prod) {
                this.activeProd = prod;
                this.activePos = pos;
                this.isaddProductSlider = true;
                this.isrequresSpaces = true;
              }
            }
            this.required_space_list = err.error.required_space_list;
          }
          this.getdiplayAddSpace();
        });
  }
  getdiplayAddSpace() {
    if (this._as.isUserLoggedIn) {
      const url = this._as.api_base_url + 'search/getspace/?project=' + this.project_id;
      this._as.getRequest(url, true)
        .subscribe((res: any) => {
          this.sysMainSpace = res.main_space_list;
          this.sysAttachedSpace = res.attached_space_list;
          if (!this.project_id || this.project_id == undefined) {
      
            let user_info:any;
            try{
              user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
            }catch (e){
              console.log(e)
            }
            this._as.user_info.directSearch.isDirectSearch = true;
            this._as.user_info.directSearch.is_address = false;
            user_info.directSearch.isDirectSearch = true;
            user_info.directSearch.is_address = false;
            this.localStorageService.setItem('user_info', JSON.stringify(user_info));
            this.project_id = res.projectId
            
          }
          setTimeout(() => {
            this.global_loader = false;
          }, 2000);
          if (this._as.isOnMobilePlatform) {
            this.mobAddSpacedisplay = true;
          } else {
            this.addSpacedisplay = true;
          }
        });
    } else {
      this._as.onLoginPage();
    }
  }
  checkMainSpaceStatus() {
    if (this._project.seleted_productList.find(spl => spl.id == this.tagged_product.id)) {
      if (this.sub_category_index >= 0) {
        for (let j = this._project.main_space_list.length - 1; j >= 0; j--) {
          let isNotFound = false;
          for (let i = this._project.main_space_list[j].sub_space_list.length - 1; i >= 0; i--) {
            const fin = this._project.main_space_list[j].sub_space_list[i].tagged_products.findIndex((item: any) => item.id == this.tagged_product.id);
            if (fin < 0) {
              isNotFound = true;
              break;
            }
          }
          if (isNotFound) {
            this._project.main_space_list[j].is_selected = false;
          } else {
            this._project.main_space_list[j].is_selected = true;
          }
        }
      }
    }
  }
  onSeletedProduct(prod?: any, pos?: any, flag?: any) {
    this._project.seleted_productList = [];
    if (this._as.user_info.is_service_provider) {
      if (!this.project_id) {
        this._project.getProjectId();
        return
      }
    } else {
      if (!this.project_id) {
        try {
          if (!this._project.selectedProject) {
            this._project.onDisplayProjects(false);
            return
          } else {
            this.project_id = this._project.selectedProject.id;

          }
        } catch (e) {
          return
        }
      }
    }
    const url = this._as.api_base_url + 'search/selectProdlist/?project=' + this.project_id + '&sub_category=' + this._qvs.productDetail.sub_category_id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        if (prod) {
          const pro_check = res.seleted_productList.filter((pr: any) => pr.id == prod.id);
          if (!pro_check.length) {
            // this._project.seleted_productList.push(prod);
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.temp_product_pos = pos;
            this.onClickSeletedProduct(prod);
          } else if (!res.seleted_productList.length) {
            // this._project.seleted_productList.push(prod);
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.temp_product_pos = pos;
            this.onClickSeletedProduct(prod);
          } else {
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.onClickSeletedProduct(prod);
          }
        }
        if (flag) {
          this.diplayAddSpace = true;
        }
        for (const obj of res.seleted_productList) {
          if (!this._project.seleted_productList.find(sp => sp.id == obj.id)) {
            this._project.seleted_productList.push(obj);
          }
        }
        if (this._project.seleted_productList.length) {
          if (this.productList.length) {
            this.countProductTaggedInSpaces();
          }
        }
        this._project.checkCart()
        this.isBtnShow = false;
        try {
          this.activekey = res.seleted_productList[0]?.key;
          this.shareLink = this._as.share_url + 'share/product-details/?key=' + prod?.slug;
          this.shareDiscription = 'Hey, I am looking for this ' + this.labelText + ' on afterbricks.com for renovating my place';
        } catch (e) {
          console.log(e);
        }
      });
  }
  countProductTaggedInSpaces() {
    throw new Error('Method not implemented.');
  }


  checkAllSpace() {
    const mslist = this._project.main_space_list.filter((ms: any) => ms.is_selected == true);
    if (mslist.length == this._project.main_space_list.length) {
      this.main_space_select_all_flag = true;
    } else {
      this.main_space_select_all_flag = false;
    }
    this.isLoadSpace = false;
    this.checkProduct_data(this.slug_name)
  }

  checkProduct_data(sub_slug_name: any) {
    const form_type = "category"
    const url = this._as.api_base_url + "user/check-cart/?project=" + this.project_id + "&form_type=" + form_type + "&slug_name=" + sub_slug_name;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.user_product_data = res.data;
        this.is_next_option = true;
        // console.log(res)
        // this.product_count = res.data.product_count
      })
  }


  onSelecteAllSpace(main_space_select_all_flag: any) {
    this.isSelectProduct = true;
    this.isBtnShow = false;
    this.selected_space_list = [];
    if (main_space_select_all_flag) {
      for (const ms of this._project.main_space_list) {
        ms.is_selected = true;
        for (const ss of ms.sub_space_list) {
          ss.is_selected = true;
          ss.tagged_products.push(this.tagged_product);
          this.selected_space_list.push(ss.id);

        }
      }
      this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      const my_data = {
        project: this.project_id ? this.project_id : this._project.selectedProject?.id,
        sub_category: this.activeSCId,
        sub_space_list: this.selected_space_list,
        product: this.tagged_product.id,
        is_status: main_space_select_all_flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if (res) {
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.tagged_product);
            // this.countSpaceTagProduct(this.tagged_product.id);
            this.isBtnShow = true;
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if (err) {
              this.isSelectProduct = false;
            }
          });
    } else {
      for (let i = 0; i < this._project.main_space_list.length; i++) {
        this._project.main_space_list[i].is_selected = false;
        for (let j = 0; j < this._project.main_space_list[i].sub_space_list.length; j++) {
          const fin = this._project.main_space_list[i].sub_space_list[j].tagged_products.findIndex((item: any) => item.id == this.tagged_product.id);
          this._project.main_space_list[i].sub_space_list[j].tagged_products.splice(fin, 1);
          this._project.main_space_list[i].sub_space_list[j].is_selected = false;
          this.selected_space_list.push(this._project.main_space_list[i].sub_space_list[j].id);
        }
      }
      this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      const my_data = {
        project: this.project_id,
        sub_category: this.activeSCId,
        sub_space_list: this.selected_space_list,
        product: this.tagged_product.id,
        is_status: main_space_select_all_flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if (res) {
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.tagged_product);
            // this.countSpaceTagProduct(this.tagged_product.id);
            this.isBtnShow = true;
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if (err) {
              this.isSelectProduct = false;
            }
          });
    }
  }
  onClickSeletedProduct(prod: any) {
    this.tagged_in_spaces_count = 0;
    for (const msl of this._project.main_space_list) {
      for (const ssl of msl.sub_space_list) {
        const product = ssl.tagged_products.filter((stp: any) => stp.id == prod.id);
        if (product.length) {
          ssl.is_selected = true;
          this.tagged_in_spaces_count += 1;

        } else {
          ssl.is_selected = false;
        }
        const mslp = msl.sub_space_list.filter((sp: any) => sp.is_selected == true);
        if (mslp.length == msl.sub_space_list.length) {
          msl.is_selected = true;
        } else {
          msl.is_selected = false;
        }
      }
    }
    if (this.tagged_in_spaces_count) {
      this._project.seleted_productList.push(prod);
    } else {
      const pi = this._project.seleted_productList.findIndex((pl: any) => pl.id == prod)
      this._project.seleted_productList.slice(pi, 1)
    }
    this.checkAllSpace();
    this.tagged_product = prod;
    this.temp_product_id = prod.id;
  }
  createUserSapce(prod: any, pos: any, user_selected_space_list: any) {
    const url = this._as.api_base_url + 'search/addallspace/';
    const data = {
      user_selected_space_list: user_selected_space_list,
    };
    this._as.postRequest(url, data, true)
      .subscribe((res: any) => {
        if (!this.project_id || this.project_id == undefined) {
          let user_info:any;
            try{
              user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
            }catch{
              user_info = {}
              return
            }
          const directSearch = {
            isDirectSearch: true,
            is_address: false,
            projectInfo: {
              id: res.prodject_id,
              isSpaceSelected: user_info.directSearch.projectInfo.isSpaceSelected
            }
          }
          this._as.user_info.directSearch = directSearch;
          user_info.directSearch = directSearch;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
          this.project_id = res.prodject_id;
          this._router.navigate(
            [],
            {
              relativeTo: this._actRouter,
              queryParams: { isProductPage: false, pId: res.prodject_id },
              queryParamsHandling: 'merge',
              replaceUrl: true
            });
          this.localStorageService.removeItem('master_main_space_list')
          this.localStorageService.removeItem('user_selected_space_list')
          this.localStorageService.removeItem('redirectTo')
        }
        this.addToSpace(prod, pos);
      });
  }
  redirectToSelectSpace(prod?: any, pos?: any, mId?: any) {
    let paramsObject: any;
    const addTask = {
      run_method: "add_product",
      prod: prod,
      pos: pos,
      product_add_action: false
    }
    this.localStorageService.setItem('addTask', JSON.stringify(addTask));
    this._actRouter.queryParamMap
      .subscribe((params: any) => {
        paramsObject = { ...params };
      }
      );
    const redirectTo = {
      link: this._router.url.split('?')[0],
      queryParams: paramsObject.params
    }
    this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
    this._router.navigate(['../../house-spaces'], { queryParams: { pId: this.project_id, isCbackprod: true, activemsid: mId ,subCat:prod.sub_category_id} })
  }

  onTagAllSubSpace(flag: any, msi: number) {
    this.isSelectProduct = true;
    this.isBtnShow = false;
    this.selected_space_list = [];
    if (flag) {
      this._project.main_space_list[msi].is_selected = true;
      this._project.main_space_list[msi].sub_space_list.forEach((ss: any) => {
        const proAvl = ss.tagged_products.find((tp: any) => tp.id == this.tagged_product.id);
        if (!proAvl) {
          ss.is_selected = true;
          ss.tagged_products.push(this.tagged_product);
          this.selected_space_list.push(ss.id);
        }
      });
      // this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      const my_data = {
        project: this.project_id,
        sub_category: this.activeSCId,
        sub_space_list: this.selected_space_list,
        product: this.tagged_product.id,
        is_status: flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if (res) {
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.tagged_product);
            // this.countSpaceTagProduct(this.tagged_product.id);
            this.isBtnShow = true;
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if (err) {
              this.isSelectProduct = false;
            }
          });
    } else {
      this._project.main_space_list[msi].is_selected = false;
      for (let j = 0; j < this._project.main_space_list[msi].sub_space_list.length; j++) {
        const fin = this._project.main_space_list[msi].sub_space_list[j].tagged_products.findIndex((item: any) => item.id == this.tagged_product.id);
        this._project.main_space_list[msi].sub_space_list[j].tagged_products.splice(fin, 1);
        this._project.main_space_list[msi].sub_space_list[j].is_selected = false;
        this.selected_space_list.push(this._project.main_space_list[msi].sub_space_list[j].id);
      }
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      const my_data = {
        project: this.project_id,
        sub_category: this.activeSCId,
        sub_space_list: this.selected_space_list,
        product: this.tagged_product.id,
        is_status: flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this.checkAllSpace();
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if (res) {
            this.isShowSummryBtn = false;
            this.isSelectProduct = false;
            this.onClickSeletedProduct(this.tagged_product);
            // this.countSpaceTagProduct(this.tagged_product.id);
            this.isBtnShow = true;
          }
        },
          (err: any) => {
            if (err) {
              this.isSelectProduct = false;
            }
          });
    }
  }

  onAddProductToSpace(ss_id: any, status: any, ms_index: any, ss_index: number) {
    this.isSelectProduct = true;
    if (status) {
      this._project.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.push(this.tagged_product)
    } else {
      const fin = this._project.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.findIndex((item: any) => item.id == this.tagged_product.id);
      this._project.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.splice(fin, 1);
    }
    // this.checkAllSpace();
    const url = this._as.api_base_url + 'search/add-to-cart-product/';
    const my_data = {
      sub_category: this.activeSCId,
      project: this.project_id,
      sub_space: ss_id,
      product: this.tagged_product.id,
      is_status: status,
      form_type: 'onebyone',
      product_add_action: this.product_add_action
    };
    this._as.postRequest(url, my_data, true)
      .subscribe((res: any) => {
        if (res) {
          this.isShowSummryBtn = false;
          this.onClickSeletedProduct(this.tagged_product);
          // this.countSpaceTagProduct(this.tagged_product.id);
          this.isBtnShow = true;
          this.isSelectProduct = false;
        }
      },
        (err: any) => {
          if (err) {
            this.isSelectProduct = false;
          }
        });


  }
  onHoverSpace(id: any) {
    this.activerSpaceID = id;
  }
  space_review() {
    let paramsObject: any;
    this._actRouter.queryParamMap
      .subscribe((params: any) => {
        paramsObject = { ...params };
      });
    const redirectonsame = {
      link: this._router.url.split('?')[0],
      queryParams: paramsObject.params
    }
    this.localStorageService.setItem('redirectonsame', JSON.stringify(redirectonsame));
    this._router.navigate([`as-collection/`], { queryParams: { pId: this.project_id, subCat: this.activeSCId, activeFlow: 'search', wId: this.slug_name } });
  }

  oncloseAddPro(flag: any,) {
    this.localStorageService.removeItem('redirectTo')
    this.localStorageService.removeItem('addTask')
    this._router.navigate([], {
      relativeTo: this._actRouter, queryParams: { isProductTagToSpace: null, activeProdId: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    this.isCloseAddSpace = true;
    if (this.isSimilarProduct) {
      this.getSimilarProducts(this.similarProductDetail)
    }
    else {
      // here return product status
      // if (this.productList[this.activePos] && !isClose)
      //   this.productList[this.activePos].is_already_selected = true
    }
    if (!flag && this.isCloseAddSpace) {
      this._project.isdisplayTagSpaces = false;
    } else {
      this._project.isdisplayTagSpaces = false;
    }
    this.isCloseAddSpace = false;
    this._project.main_space_list = [];
    this._project.checkCart();
    this._sl.getAllSpacesWidthProductCount();
  }
  getSimilarProducts(prod: any) {
    this.isSimilarProduct = true;
    this.similarProductDetail = prod;
    this.displaySimilarProducts = true;
    this.similar_product_loading = true;
    let url: any;
    if (this.project_id) {
      url = this._as.api_base_url + "product/similar-product/?sub_cat_slug=" + this.sub_slug_name + "&slug_name=" + prod.slug_name + "&page=" + this.spPage + "&project=" + this.project_id + "&sub_category=" + this.activeSCId;
    }
    else {
      url = this._as.api_base_url + "product/similar-product/?sub_cat_slug=" + this.sub_slug_name + "&slug_name=" + prod.slug_name + "&page=" + this.spPage + "&sub_category=" + this.activeSCId;
    }
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.similar_product_loading = false;
        this.total_products = res.total_found_products;
        this.total_pages = res.total_num_of_pages;
        if (res.products.length) {
          this.similar_product_list = [];
          res.products.forEach((prod: any) => {
            prod.is_addtocart = false
            prod.is_already_selected = false
            if (res.user_products.length) {
              const user_product = res.user_products.find((up: any) => up.product_id == prod.id)
              if (user_product) {
                if (user_product.is_addtocart) {
                  prod.is_addtocart = true
                } else {
                  prod.is_already_selected = true
                }
              }
            }
            this.similar_product_list.push(prod)
          })
        }
      },
        (err: any) => {
          if (err) {
            this.similar_product_loading = false;
          }
        });
  }
  
}
